/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Junior_TitleInputs */

const en_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Development`)
};

const es_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo junior`)
};

const de_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior-Entwicklung`)
};

const zh_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青少年培养`)
};

const ar_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير الناشئين`)
};

const fr_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement junior`)
};

const vi_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đào tạo tài năng trẻ`)
};

const sw_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maendeleo ya Vijana`)
};

const th_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พัฒนาการจูเนียร์`)
};

const bs_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razvoj juniora`)
};

const ja_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジュニア育成`)
};

const ko_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주니어 육성`)
};

const pt_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento júnior`)
};

const it_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppo Junior`)
};

const sv_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorutveckling`)
};

const nl_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorontwikkeling`)
};

const da_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorudvikling`)
};

const nb_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorutvikling`)
};

const fi_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junioriohjelma`)
};

const pl_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwój młodzieży`)
};

const ru_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юниорская программа`)
};

const tr_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genç Oyuncu Gelişimi`)
};

const hi_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जूनियर विकास`)
};

const id_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembangan Junior`)
};

const ms_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangunan Junior`)
};

const cs_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vývoj juniorů`)
};

const el_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανάπτυξη νέων παικτών`)
};

const he_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פיתוח ג'וניור`)
};

const af_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorontwikkeling`)
};

const hu_lessons_format_junior_title = /** @type {(inputs: Lessons_Format_Junior_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior fejlesztés`)
};

/**
* | output |
* | --- |
* | "Junior Development" |
*
* @param {Lessons_Format_Junior_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_junior_title = /** @type {((inputs?: Lessons_Format_Junior_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Junior_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_junior_title(inputs)
	if (locale === "de") return de_lessons_format_junior_title(inputs)
	if (locale === "zh") return zh_lessons_format_junior_title(inputs)
	if (locale === "ar") return ar_lessons_format_junior_title(inputs)
	if (locale === "fr") return fr_lessons_format_junior_title(inputs)
	if (locale === "vi") return vi_lessons_format_junior_title(inputs)
	if (locale === "sw") return sw_lessons_format_junior_title(inputs)
	if (locale === "th") return th_lessons_format_junior_title(inputs)
	if (locale === "bs") return bs_lessons_format_junior_title(inputs)
	if (locale === "ja") return ja_lessons_format_junior_title(inputs)
	if (locale === "ko") return ko_lessons_format_junior_title(inputs)
	if (locale === "pt") return pt_lessons_format_junior_title(inputs)
	if (locale === "it") return it_lessons_format_junior_title(inputs)
	if (locale === "sv") return sv_lessons_format_junior_title(inputs)
	if (locale === "nl") return nl_lessons_format_junior_title(inputs)
	if (locale === "da") return da_lessons_format_junior_title(inputs)
	if (locale === "nb") return nb_lessons_format_junior_title(inputs)
	if (locale === "fi") return fi_lessons_format_junior_title(inputs)
	if (locale === "pl") return pl_lessons_format_junior_title(inputs)
	if (locale === "ru") return ru_lessons_format_junior_title(inputs)
	if (locale === "tr") return tr_lessons_format_junior_title(inputs)
	if (locale === "hi") return hi_lessons_format_junior_title(inputs)
	if (locale === "id") return id_lessons_format_junior_title(inputs)
	if (locale === "ms") return ms_lessons_format_junior_title(inputs)
	if (locale === "cs") return cs_lessons_format_junior_title(inputs)
	if (locale === "el") return el_lessons_format_junior_title(inputs)
	if (locale === "he") return he_lessons_format_junior_title(inputs)
	if (locale === "af") return af_lessons_format_junior_title(inputs)
	if (locale === "hu") return hu_lessons_format_junior_title(inputs)
	return en_lessons_format_junior_title(inputs)
});